export default __webpack_public_path__ + "static/media/1893.27e1c3ce.png";